// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { TimeBaseEntity } from '../time-base-entity';
import { TimeEntryImportBill } from './time-entry-import-bill';
import { TimeEntryImportDetail } from './time-entry-import-detail';

/// <code-import> Place custom imports between <code-import> tags
export type TimeEntryImportFlags = 'Complete' | 'Abandoned' | 'Staging' | 'ReadyForReview' | 'Processing' | 'Failed';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TimeEntryImport extends TimeBaseEntity  {

  /// <code> Place custom code between <code> tags
  hasFlag(flag: TimeEntryImportFlags): boolean {
    const flags = this.parseFlags();
    return flags.some((f) => f === flag);
  }

  setFlag(flag: TimeEntryImportFlags): void {
    if (this.hasFlag(flag)) {
      return;
    }

    const flags = this.parseFlags();
    flags.push(flag);
    this.flags = flags.join(', ') || '0';
  }

  clearFlag(flag: TimeEntryImportFlags): void {
    if (!this.hasFlag(flag)) {
      return;
    }

    const flags = this.parseFlags();
    flags.splice(flags.indexOf(flag), 1);
    this.flags = flags.join(', ') || '0';
  }

  private parseFlags(): string[] {
    const flags = this.flags || '0'; // Could be numeric zero
    if (flags === '0') {
      return [];
    }
    return flags.split(',').map((flag) => flag.trim());
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  createdAt!: Date;
  createdBy?: string;
  error?: string;
  flags!: string;
  practiceId!: number;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
  timeEntryImportBills!: TimeEntryImportBill[];
  timeEntryImportDetails!: TimeEntryImportDetail[];
}

